import React from "react";
import { useLocation } from "react-router-dom";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import AddBalanceChild from "./AddBalanceChild";

const AddBalance = () => {
  const { state } = useLocation();
  const selectedBank = state;
  return (
    <MainTemplate>
      <CardBackground>
        <AddBalanceChild selectedBank={selectedBank} />
      </CardBackground>
    </MainTemplate>
  );
};

export default AddBalance;
